import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import Config from 'src/common/Config';
import useFlagOverrides from './useFlagOverrides';

export type Flags = {
  showDataUploadCounts: boolean;
  flagEnabledComplianceChecking: boolean;
  flagEnabledDocumentEdit: boolean;
  flagEnabledMeetingNoteFromAgenda: boolean;
  flagEnabledMeetingNoteSummarisation: boolean;
  flagEnabledMaintenanceMode: boolean;
  flagEnabledNewSuitabilityReviewedState: boolean;
  flagEnabledFactFindSelfService: boolean;
  flagEnabledMeetingNoteFromDocument: boolean;
  flagEnabledMeetingNoteEdit: boolean;
  flagEnabledBotMigration: boolean;
  flagEnabledObjectivesRework: boolean;
  flagEnabledTranscriptionOnClientCreation: boolean;
  flagEnabledBulkValControlCentre: boolean;
  flagEnabledMeetingNoteCitations: boolean;
  flagEnabledSiestaSteering: boolean;
  flagEnabledAutoModelTypeSelection: boolean;
  flagEnabledBatchCrudDataUpload: boolean;
  flagEnabledInlineEdit: boolean;
  flagEnabledFamilyFlowFrontend: boolean;
  flagEnabledUseDocXSkillForAgendaBackfill: boolean;
};

export function useFlags(): Flags {
  const ldFlags = useLDFlags<Flags>();
  const { overrides } = useFlagOverrides();
  if (!Config.isDev()) return ldFlags;
  return { ...ldFlags, ...overrides };
}
